<template>
  <div :class="`d-flex ${alignment}`">
    <div class="d-flex progress-bars-container">
      <span
        v-for="i of progress"
        :key="'completed ' + i"
        :style="completedStyle"
        :class="`bg-${type}`"
        class="mr-1 rounded-pill px-1 py-2"
      />
      <span
        v-for="i of incomplete"
        :key="'incomplete' + i"
        :class="`${uncompletedBgClass} mr-1 rounded-pill px-1 py-2`"
      />
    </div>
    <slot>
      <div class="font-weight-bolder">
        {{ completed > 0 ? `${completed.toFixed(0)}%` : '00%' }}
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    completed: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      default: 'nitro',
    },
    alignment: {
      type:String,
      default: 'justify-content-md-around align-items-center'
    },
    uncompletedBgClass: {
      type: String,
      default: 'bg-white'
    },
    completedStyle: {
      type: String,
      default: ''
    }
  },
  computed: {
    incomplete() {
      return parseInt(10 - this.progress);
    },
    progress() {
      return parseInt(Math.ceil(this.completed / 10));
    },
  }
}
</script>
<style scoped lang="scss">
.progress-bars-container {
  span {
    height: 25px;
  }
}
</style>

